<template>
  <vx-card class="mt-base" :title="activityTitle">
    <p class="mb-5">
      It isn’t only vets and vet nurses who bear the responsibility for taking care of pets. In
      fact, most of the burden of care falls on the shoulders of the pet owner. They are the ones
      who are ultimately responsible for meeting their pet’s needs. These needs include:
    </p>
    <img
      src="@/assets/images/experiences/vet/choose_pets_450.jpg"
      alt=""
      class="my-2 ml-2 mb-2 float-right"
    />

    <ul class="default-list">
      <li>Providing a secure home</li>
      <li>Exercising</li>
      <li>Feeding</li>
      <li>Playing</li>
      <li>Vet visits.</li>
    </ul>

    <p class="mb-5">
      As an animal health professional, there’ll be times when you’ll advise people on how to choose
      a pet that suits their specific situation.
    </p>
    <p class="mb-5">
      Which species best suits an individual’s needs will depend a lot on their personal
      circumstances. Some aspects to consider include:
    </p>
    <ul class="default-list">
      <li>How much space they have</li>
      <li>How many exercise opportunities they can provide</li>
      <li>How much time they’ll have to spend taking care of the animal’s needs</li>
      <li>How much money they can afford to spend</li>
      <li>How much they know about taking care of this type of animal.</li>
    </ul>

    <h4 class="mb-5">Which Pet Should I Own?</h4>
    <p class="mb-5">
      Now, it’s time to find out which pet you should own. Use the following link to take the brief
      PDSA quiz on how to choose a new pet. This is a UK website, so the costs listed are in GBP£.
      To get an idea of what these costs would be in AUD$, you can use a currency convertor such as
      <a href="https://www.xe.com/currencyconverter/" target="_blank">XE Currency Convertor</a>.
    </p>
    <p class="mb-5">Now, time to take the quiz:</p>
    <p class="mb-5">
      <a href="https://www.pdsa.org.uk/taking-care-of-your-pet/choosing-a-pet" target="_blank"
        >https://www.pdsa.org.uk/taking-care-of-your-pet/choosing-a-pet</a
      >
    </p>
    <p class="mb-5">
      When you’ve completed the quiz, you’ll see anywhere between one and nine pet options
      generated. List these options below:
    </p>

    <div v-for="index in 9" :key="index" class="overflow-hidden">
      <p class="float-left" style="padding: 8px 5px 0; width: 20px" v-if="isEditable">
        {{ index }}:
      </p>
      <p class="float-left py-5 pr-2" v-else>{{ index }}:</p>
      <text-block v-model="data['question' + index]" :editable="isEditable" />
    </div>
    <p class="mb-5">
      Of the options generated, which of one of these is the most appealing to you?
    </p>
    <text-block v-model="data['question10']" :editable="isEditable" />
    <vs-divider />

    <h4 class="mb-5">Which Pets Should They Own?</h4>
    <p class="mb-5">
      Now it’s time to practice helping other people find out what pet best suits their needs. Use
      the questionnaire below to record the answers to the same questions you just answered. Once
      you’ve received their answers, you can input them into the same online PDSA quiz to generate
      some suggestions to suit their needs.
    </p>
    <p class="mb-5">
      You can ask family members, friends, classmates, etc. You could even do this brief
      questionnaire over the phone, via text messaging, email, Zoom, etc, if you need to.
    </p>
    <p class="mb-5">
      <a
        :href="'content/vet/choosing_a_pet_sheet.pdf' | blob_url"
        target="_blank"
        class="no-underline btn btn-secondary btn-size-medium includedIcon"
      >
        <download-icon />Download Pet Questionnaire
      </a>
    </p>
    <p class="mb-5">
      Do the questionnaire for at least three different people. Feed their results into the online
      quiz and generate some pet suggestions. Record the generated suggestions for each person in
      the table below:
    </p>

    <table class="table default-table">
      <tr class="header">
        <th width="50%">Name</th>
        <th>Pet Suggestions</th>
      </tr>
      <tr class="body" v-for="index in 3" :key="index">
        <td>
          <text-block v-model="data['question' + (10 + index) + '_1']" :editable="isEditable" />
        </td>
        <td>
          <text-block v-model="data['question' + (10 + index) + '_2']" :editable="isEditable" />
        </td>
      </tr>
    </table>
    <save-buttons :is-editable="isEditable" @save="save" />
  </vx-card>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
import { DownloadIcon } from 'vue-feather-icons';

export default {
  components: {
    DownloadIcon,
  },
  data() {
    return {
      videoTrigger1: require('@/assets/images/experiences/psychology/positive_refaming_trigger.jpg'),
      videos: {
        1: 'https://www.youtube.com/embed/0tqq66zwa7g',
      },
      login_type: localStorage.getItem('login_type'),
      answers: {
        question1: null,
        question2: null,
        question3: null,
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
};
</script>

<style scoped>
.wrong {
  background: rgba(202, 20, 20, 0.24);
  border-bottom: 1px solid #f8f8f8;
  padding-top: 2px;
}
.correct {
  background: rgba(75, 202, 20, 0.24);
  border-bottom: 1px solid #f8f8f8;
}
.scale-header {
  background: #f5f5f5;
  padding-top: 5px;
  font-weight: 600;
}
</style>
